<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-layer-plus', fontSet: 'fad'}"
	[headerText]="data.title"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<mat-form-field class="full-width-form" color="accent" subscriptSizing="dynamic">
			<mat-label>{{ T.CREATE_BY_NAME_DIALOG_NAME_LABEL | translate }}</mat-label>
			<input [formControl]="formCtrl" matInput type="text" />
			<mat-error>{{ T.CREATE_BY_NAME_DIALOG_NAME_REQUIRED | translate }}</mat-error>
		</mat-form-field>
	</ng-container>

	<ng-container actions>
		<button (click)="close()" color="warn" mat-raised-button style="margin-right: 20px">
			{{ T.CREATE_BY_NAME_DIALOG_CLOSE_BUTTON | translate }}
		</button>

		<button (click)="createNewItem()" [disabled]="formCtrl.invalid" color="accent" mat-raised-button>
			{{ T.CREATE_BY_NAME_DIALOG_CREATE_BUTTON | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
